import { Avatar, Button, Dropdown, Grid, Layout, Space, Typography } from 'antd';
import { LogoutOutlined, MenuOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../features/auth/stores/authStore';
import { NotificationBell } from './NotificationBell';

const { Header } = Layout;
const { Text } = Typography;

interface TopbarProps {
  showMenuButton?: boolean;
  onMenuClick?: () => void;
}

export function Topbar({ showMenuButton, onMenuClick }: TopbarProps): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const screens = Grid.useBreakpoint();
  // En pantallas muy chicas dejamos solo el avatar (sin nombre/rol).
  const showUserText = screens.sm;

  const handleLogout = async (): Promise<void> => {
    await logout();
    navigate('/login', { replace: true });
  };

  const initials = user
    ? `${(user.firstName?.[0] ?? '').toUpperCase()}${(user.lastName?.[0] ?? '').toUpperCase()}`
    : '?';

  return (
    <Header
      style={{
        background: '#fff',
        padding: '0 16px',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: showMenuButton ? 'space-between' : 'flex-end',
        gap: 12,
      }}
    >
      {showMenuButton && (
        <Button
          type="text"
          aria-label="Abrir menú"
          icon={<MenuOutlined />}
          onClick={onMenuClick}
        />
      )}
      <Space size="middle">
        <NotificationBell />
        <Dropdown
        trigger={['click']}
        menu={{
          items: [
            {
              key: 'profile',
              icon: <UserOutlined />,
              label: 'Mi perfil',
              onClick: () => navigate('/perfil'),
            },
            { type: 'divider' },
            {
              key: 'logout',
              icon: <LogoutOutlined />,
              label: 'Cerrar sesión',
              danger: true,
              onClick: () => {
                void handleLogout();
              },
            },
          ],
        }}
      >
        <Space style={{ cursor: 'pointer' }}>
          <Avatar style={{ backgroundColor: '#1677ff' }}>{initials}</Avatar>
          {showUserText && (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
              <Text strong>
                {user?.firstName} {user?.lastName}
              </Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {user?.role}
              </Text>
            </div>
          )}
        </Space>
        </Dropdown>
      </Space>
    </Header>
  );
}
